import { BookOwnership, BookStatus, ScriptStatus } from '../common/enums';

export class BookcaseInfoDTO {
	
	id:number|null = null;
	userId:number|null = null; //책장 소유자 아이디  
    name:string|null = null;
	forReading:boolean|null = null; //독서용도여부
	forScript:boolean|null = null; //필사용도여부
	isDefault:boolean|null = null; //기본책장 여부
	createdAt:Date|null = null;
}

export class BookcaseInputReqDTO {
	userId:number|null = null; //책장 소유자 아이디  
	name:string|null = null;
	forReading:boolean|null = null; //독서용도여부
	forScript:boolean|null = null; //필사용도여부
}





export class BookcaseBookInfoDTO {
	bookcaseId:number|null = null;
    bookId:number|null = null;
	ownership:BookOwnership|null = null;
	bookStatus:BookStatus|null = null;
	score:number|null = null;
	readPage:number|null = null;
	readFr:Date|null = null;
	readTo:Date|null = null;
	scriptFr:Date|null = null;
	scriptTo:Date|null = null;
	isbn:string|null = null; 
	isbn13:string|null = null; 
	title:string|null = null; 
	cover:string|null = null;
	author:string|null = null; 
	publisher:string|null = null; 
	category:string|null = null; 
	pageNum:number|null = null; 
	publishedAt:Date|null = null; 
	createdAt:Date|null = null;
}



export class BookUserInputReqDTO {
	bookId: number|null = null;
	userId: number|null = null;
	ownership: BookOwnership|null = null;
	bookStatus: BookStatus|null = null;
	scriptStatus: ScriptStatus|null = null;
	score: number|null = null;
	pageNum: number|null = null;
	readPage: number|null = null;
	readFr: Date|null = null;
	readTo: Date|null = null;
	scriptFr: Date|null = null;
	scriptTo: Date|null = null;
	bookcases: number[]|null = null;
}

export class BookUserInfoDTO {
	id:number|null = null;
	bookId:number|null = null;
	userId:number|null = null;
	ownership: BookOwnership|null = null;
	bookStatus: BookStatus|null = null;
    scriptStatus: ScriptStatus|null = null;
	score:number|null = null;
	readPage:number|null = null;
	scriptPage:number|null = null;
	readFr:Date|null = null;
	readTo:Date|null = null;
	scriptFr:Date|null = null;
	scriptTo:Date|null = null;
	isbn:string|null = null; 
	isbn13:string|null = null; 
	title:string|null = null; 
	cover:string|null = null;
	author:string|null = null; 
	publisher:string|null = null; 
	category:string|null = null; 
	pageNum:number|null = null; 
	publishedAt:Date|null = null; 
	createdAt:Date|null = null;
	bookcases:BookcaseInfoDTO[]|null = null;
}
	
export class BookUserMemoDTO {
	id:number|null = null;
	bookUserId:number|null = null;  
	memo:string|null = null;
	createdAt:Date|null = null;	
}

export class BookUserRecordDTO {
	id:number|null = null;
	bookUserId:number|null = null;  
	startAt:Date|null = null;  
	endAt:Date|null = null;  
	createdAt:Date|null = null;
}


export class BookUserRecordTotalDTO {

	bookUserId:number|null = null;  
	totalTimeInSec:number|null = null;  
	totalCnt:number|null = null;  
}


export class NoobookScheduleDTO {
	
	title:string|null = null;
	bookId:number|null = null;
	imgUrl:string|null = null;
	startAt:Date|null = null;
	endAt:Date|null = null;
	schType:number|null = null; // 1 : read, 2 : script
}


export class BookUserMemoCntDTO {

	bookUserId:number|null = null;   
	memoCnt:number|null = null;  
}


export class BookUserScriptDTO {

	id:number|null = null;
	bookUserId:number|null = null;  
	imageId:number|null = null;
	imageUrl:string|null = null;
	tmpImgFileId:string|null = null;
	createdAt:Date|null = null;
}


export class BookUserStatisticsDTO {

	doneCnt:number|null = null; 
	inProgressCnt:number|null = null; 
	memoCnt:number|null = null; 
	totalTakenTime:number|null = null; 
}



	
	





